import bus from '@/utils/eventBus'

export default function () {
  bus.$on('document-cart-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
  bus.$on('document-cpf-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
  bus.$on('document-dipl-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
  bus.$on('document-cert-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
  bus.$on('document-cend-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
  bus.$on('document-cnpj-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
  bus.$on('document-outr-submitted', values => {
    if (values.redrect) {
      return this.$router.push({name: 'professional.documents.index'})
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/documents/form/resources/mounted.js